import api from './api';

export const couponAPI = {
  getAllCoupons: async () => {
    const response = await api.get('/coupon/get-all');
    return response.data;
  },
  getCouponById: async (id: string) => {
    const response = await api.get(`/coupon/get-details/${id}`);
    return response.data;
  },
  createCoupon: async (data: any) => {
    const response = await api.post('/coupon/create', data);
    return response.data;
  },
  updateCoupon: async (id: string, data: any) => {
    const response = await api.put(`/coupon/update/${id}`, data);
    return response.data;
  },
  deleteCoupon: async (id: string) => {
    const response = await api.delete(`/coupon/delete/${id}`);
    return response.data;
  },
};